import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homePageWidth"},[_c(VRow,[_c(VCol,{staticClass:"mt-15",attrs:{"cols":"12"}}),_c(VCol,{staticClass:"pt-0",attrs:{"cols":"12","xl":"2","lg":"2","md":"2","sm":"12","xs":"12"}}),_c(VCol,{staticClass:"pt-0",attrs:{"cols":"12","xl":"8","lg":"8","md":"8","sm":"12","xs":"12"}},[_c('NewsMainPage')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }